import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { collection, query, where, getDocs } from "firebase/firestore";
import db from "./Firebase";
import Moment from 'moment';
import { extendMoment } from 'moment-range';

function UdyamRegistrationData() {
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [personalDetails, setPersonalDetails] = useState({});
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        const unsubscribe = db.collection("udyam_registration_submitted_data")
            .orderBy("createdAt", "desc")
            .onSnapshot((snapshot) => {
                const udyamData = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data()
                }));
                setData(udyamData);
                fetchPersonalDetails(udyamData); // Fetch names after data is loaded
            });

        return () => unsubscribe();
    }, []);

    const fetchPersonalDetails = async (entries) => {
        const phoneNumbers = [...new Set(entries.map(({ data }) => data.phone))];

        if (phoneNumbers.length === 0) return;

        let detailsMap = {};
        const batchSize = 10;

        for (let i = 0; i < phoneNumbers.length; i += batchSize) {
            const batch = phoneNumbers.slice(i, i + batchSize);
            const q = query(collection(db, "personal_details"), where("phone_no", "in", batch));

            const snapshot = await getDocs(q);
            snapshot.docs.forEach((doc) => {
                const d = doc.data();
                detailsMap[d.phone_no] = d.full_name || "N/A";
            });
        }

        setPersonalDetails(detailsMap);
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    const filteredData = data.filter(({ data }) =>
        data.phone?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <div className="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <div className="card-header pb-0 px-3">
                    <h6 className="mb-2">Udyam Registrations</h6>
                </div>
                <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    placeholder="Search by Phone Number"
                    value={searchQuery}
                    onChange={handleSearch}
                />

                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Funder</th>
                                <th>Created At</th>
                                <th>Responses</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map(({ id, data }, index) => (
                                <tr key={id}>
                                    <td>{index + 1}</td>
                                    <td>{personalDetails[data.phone] || "Loading..."}</td>
                                    <td>{data.phone || "N/A"}</td>
                                    <td>{data.funder || "N/A"}</td>
                                    <td>{data.createdAt?.toDate ? moment(data.createdAt.toDate()).format("DD/MM/YY, h:mm a") : "N/A"}</td>
                                    <td>
                                        {data.responses?.map((resp, i) => (
                                            <div key={i}>
                                                <strong>Q:</strong> {resp.question}<br />
                                                <strong>A:</strong> {resp.answer}<br />
                                                <hr />
                                            </div>
                                        )) || "No responses"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default UdyamRegistrationData;
